/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GrantEarlyAccessRequest,
} from '../models/index';
import {
    GrantEarlyAccessRequestFromJSON,
    GrantEarlyAccessRequestToJSON,
} from '../models/index';

export interface GrantEarlyAccessOperationRequest {
    grantEarlyAccessRequest: GrantEarlyAccessRequest;
}

export interface ListEarlyAccessRequest {
    tenantId: string;
}

export interface RevokeEarlyAccessRequest {
    tenantId: string;
    featureId: string;
}

/**
 * EarlyAccessAdminApi - interface
 * 
 * @export
 * @interface EarlyAccessAdminApiInterface
 */
export interface EarlyAccessAdminApiInterface {
    /**
     * Creates an entitlement with source=EARLY_ACCESS; expiry in effective_to
     * @summary Grant early access (admin)
     * @param {GrantEarlyAccessRequest} grantEarlyAccessRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarlyAccessAdminApiInterface
     */
    grantEarlyAccessRaw(requestParameters: GrantEarlyAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Creates an entitlement with source=EARLY_ACCESS; expiry in effective_to
     * Grant early access (admin)
     */
    grantEarlyAccess(requestParameters: GrantEarlyAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Rows from tenant_entitlement with source=EARLY_ACCESS. Use UI filter to include expired.
     * @summary List early access grants for tenant (admin)
     * @param {string} tenantId Tenant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarlyAccessAdminApiInterface
     */
    listEarlyAccessRaw(requestParameters: ListEarlyAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Rows from tenant_entitlement with source=EARLY_ACCESS. Use UI filter to include expired.
     * List early access grants for tenant (admin)
     */
    listEarlyAccess(requestParameters: ListEarlyAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Removes tenant_entitlement with source=EARLY_ACCESS for this feature
     * @summary Revoke early access (admin)
     * @param {string} tenantId Tenant ID
     * @param {string} featureId Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarlyAccessAdminApiInterface
     */
    revokeEarlyAccessRaw(requestParameters: RevokeEarlyAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Removes tenant_entitlement with source=EARLY_ACCESS for this feature
     * Revoke early access (admin)
     */
    revokeEarlyAccess(requestParameters: RevokeEarlyAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class EarlyAccessAdminApi extends runtime.BaseAPI implements EarlyAccessAdminApiInterface {

    /**
     * Creates an entitlement with source=EARLY_ACCESS; expiry in effective_to
     * Grant early access (admin)
     */
    async grantEarlyAccessRaw(requestParameters: GrantEarlyAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['grantEarlyAccessRequest'] == null) {
            throw new runtime.RequiredError(
                'grantEarlyAccessRequest',
                'Required parameter "grantEarlyAccessRequest" was null or undefined when calling grantEarlyAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/early-access`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GrantEarlyAccessRequestToJSON(requestParameters['grantEarlyAccessRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Creates an entitlement with source=EARLY_ACCESS; expiry in effective_to
     * Grant early access (admin)
     */
    async grantEarlyAccess(requestParameters: GrantEarlyAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.grantEarlyAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rows from tenant_entitlement with source=EARLY_ACCESS. Use UI filter to include expired.
     * List early access grants for tenant (admin)
     */
    async listEarlyAccessRaw(requestParameters: ListEarlyAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling listEarlyAccess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/early-access`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Rows from tenant_entitlement with source=EARLY_ACCESS. Use UI filter to include expired.
     * List early access grants for tenant (admin)
     */
    async listEarlyAccess(requestParameters: ListEarlyAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listEarlyAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes tenant_entitlement with source=EARLY_ACCESS for this feature
     * Revoke early access (admin)
     */
    async revokeEarlyAccessRaw(requestParameters: RevokeEarlyAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling revokeEarlyAccess().'
            );
        }

        if (requestParameters['featureId'] == null) {
            throw new runtime.RequiredError(
                'featureId',
                'Required parameter "featureId" was null or undefined when calling revokeEarlyAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/early-access/{tenantId}/{featureId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));
        urlPath = urlPath.replace(`{${"featureId"}}`, encodeURIComponent(String(requestParameters['featureId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Removes tenant_entitlement with source=EARLY_ACCESS for this feature
     * Revoke early access (admin)
     */
    async revokeEarlyAccess(requestParameters: RevokeEarlyAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.revokeEarlyAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
